import React from "react";
import { useNavigate } from "react-router-dom";
import "./Topics.css";

type TopicsProps = {
  topic: {
    title: string;
    icon: React.ReactNode;
    link: string;
  }[];
  active: number;
  callback?: (index: number) => void;
};

export function Topics(props: TopicsProps) {
  const navigate = useNavigate();

  function activeInHover(event: React.MouseEvent<HTMLDivElement>) {
    const parent = event.currentTarget.parentElement;
    if (!parent) return;

    const topicItems = parent.getElementsByClassName("topicItem");
    for (let i = 0; i < topicItems.length; i++) {
      topicItems[i].classList.remove("topicItemActive");
    }

    event.currentTarget.classList.add("topicItemActive");
  }

  function removeActiveTopic(
    event: React.MouseEvent<HTMLDivElement> | null = null,
  ) {
    const parent = event ? event.currentTarget.parentElement : document;
    if (!parent) return;

    const pageLen = window.location.pathname.split("/");
    const page = pageLen[pageLen.length - 1];
    const topicItems = parent.getElementsByClassName("topicItem");

    for (let i = 0; i < topicItems.length; i++) {
      topicItems[i].classList.remove("topicItemActive");
    }

    for (let i = 0; i < props.topic.length; i++) {
      const topic = props.topic[i];
      const topicLen = topic.link.split("/");
      const topicPage = topicLen[topicLen.length - 1];
      if (page !== topicPage) continue;

      topicItems[i].classList.add("topicItemActive");
      break;
    }
  }

  return (
    <div className="topicList">
      {props.topic.map((topic, index) => (
        <div
          key={Math.random()}
          className={
            index === props.active ? "topicItem topicItemActive" : "topicItem"
          }
          onClick={() => {
            props.callback && props.callback(index);
            navigate(topic.link);
          }}
          onMouseOver={activeInHover}
          onMouseOut={removeActiveTopic}
        >
          {topic.icon}
          <span>{topic.title}</span>
        </div>
      ))}
    </div>
  );
}
